export default __webpack_public_path__ + "static/media/programmer2.67c5305d.png";